<template>
  <balance :title="title" :cols="cols" :url="url" :showAccountFilters="false" />
</template>

<script>
import Balance from "../Balance";

export default {
  name: "AccountsBalance",
  components: { Balance },
  props: {
    is_cost_center: {
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    title() {
      return "تراز حساب های شناور ";
    },
    cols() {
      let text = "تفضیلی شناور";
      return {
        cols: [
          {
            text: text,
            value: "float_account_name",
            type: "text"
          }
        ]
      };
    },
    url() {
      return `reports/balance/floats&`;
    },
  }
};
</script>